import { createContext } from 'react';

export type FrState = {
    wasHeldEventsModalShown: boolean;
    setWasHeldEventsModalShown: React.Dispatch<React.SetStateAction<boolean>>;
};

export const FrStateContext = createContext<FrState | undefined>(undefined);
